import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BodyClass = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        if (location.pathname === '/contatos') {
            document.body.classList.add('contato-page');
        } else {
            document.body.classList.remove('contato-page');
        }

        return () => {
            document.body.classList.remove('contato-page');
        };
    }, [location.pathname]);

    return null;
};

export default BodyClass;